import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';

import { getRoomId, androidBackButton } from './Utils';
import QRCode from 'react-qr-code';

//must delete this page
class QRCodePage extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      //timeoutID: 0,

      roomID: getRoomId(),
      roomHasAlreadyStarted: false,
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleGoBackRoom = () => {
    //this.props.navigate(`/Lobby/${getRoomId()}`);
    this.props.navigate(-1);
  };

  render() {
    return (
      <div className="Home">
        <h1
          className="joinRoomH1"
          style={{ position: 'absolute', top: '0px', fontFamily: 'Poppins' }}>
          QR код
        </h1>

        <div className="arrowBackButtonDiv">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <p className="noGamesFoundExplanationText">
          Сканирай QR код, за да влезнеш в играта
        </p>

        <div className="QROutline">
          <div className="QRwhiteBackground">
            <QRCode
              size={256}
              style={{
                height: '90%',
                maxWidth: '90%',
                width: '90%',
              }}
              value={this.state.roomID}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>
        <p>{this.state.roomID}</p>
      </div>
    );
  }
}

export default withCookies(QRCodePage);
